import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLanguage,
  faPlayCircle,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import languagesData from "../data/languages.json";
import "../styles/languages.css";

const Languages = () => {
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");
  const [showModal, setShowModal] = useState(false);

  const fluencyData = {
    3: { label: "Native", class: "native", color: "#4CAF50" },
    2: { label: "Fluent", class: "fluent", color: "#2196F3" },
    1: { label: "Conversational", class: "conversational", color: "#FFC107" },
    0: { label: "Beginner", class: "beginner", color: "#9E9E9E" }
  };

  const handlePlay = (url) => {
    setCurrentVideoUrl(url);
    setShowModal(true);
  };

  const getEmbedUrl = (url) => {
    // YouTube
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = url.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/);
      return videoId ? `https://www.youtube.com/embed/${videoId[1]}?autoplay=1` : url;
    }
    // Loom
    if (url.includes('loom.com')) {
      return url.includes('/embed/') ? url : url.replace('/share/', '/embed/');
    }
    return url;
  };

  return (
    <div className="languages-container">
      <div className="languages-header">
        <FontAwesomeIcon icon={faLanguage} className="header-icon" />
        <h2>Language Proficiency</h2>
        <p>Click to hear my language skills</p>
      </div>

      <div className="languages-grid">
        {languagesData.map((language, index) => {
          const fluency = fluencyData[language.fluency] || fluencyData[0];
          return (
            <div key={index} className={`language-card ${fluency.class}`}>
              <div className="card-content">
                <h3>{language.name}</h3>
                <p>{language.description}</p>
                <div className="fluency-meter">
                  <div className="fluency-level" style={{
                    width: `${(language.fluency / 3) * 100}%`,
                    backgroundColor: fluency.color
                  }}></div>
                </div>
                <div className="card-footer">
                  <span style={{ color: fluency.color }}>{fluency.label}</span>
                  <button 
                    onClick={() => handlePlay(language.recording)}
                    className="play-btn"
                  >
                    <FontAwesomeIcon icon={faPlayCircle} />
                    <span>Listen</span>
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {showModal && (
        <div className="video-modal">
          <div className="modal-backdrop" onClick={() => setShowModal(false)}></div>
          <div className="modal-box">
            <button className="close-btn" onClick={() => setShowModal(false)}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <div className="video-wrapper">
              <iframe
                src={getEmbedUrl(currentVideoUrl)}
                title="Language recording"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Languages;